import { Component, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { StorageService } from 'src/app/services/storage.service';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  date = new Date();
  hospitalId: any;
  isHospitalApp: any;
  completeSpecialties: any;
  constructor(private router: Router, private ngZone: NgZone, private apiService: ApiService,) {

  }

  // Fetch departments for the selected branch
 getDepartmentsForBranch(branchId: string) {
  this.apiService.getBranchDepartments(branchId).subscribe({
   next: (response: any) => {
      if (response.success === true) {
        this.completeSpecialties = response.data.data.slice(0, 6);
      }
    },
    error: (err: any) => {
    },
    complete: () => {
    }
  });
}

  // Api call for getting all Hospital Departments
  getSpecialties(){
    this.apiService.getDepartments().subscribe((response: any) => {
      if (response.success === true) {
        this.completeSpecialties = response.data.data.slice(0, 6);
      } 
    });
  }

  // Function for storing speciality to get doctors according to speciality & navigating to doctors page
  gotoSpecialityDoctorsList(specialty?: any) {
    this.router.navigate(['/doctors', { specialtyId: specialty.id }]);
  }

  // NgOnInit function
  ngOnInit(): void { 
    this.isHospitalApp = environment.isHospitalApp; 
    this.hospitalId = environment.hospitalId; 
    if (!this.isHospitalApp) { 
      this.getSpecialties();
    } else {
      this.getDepartmentsForBranch(this.hospitalId);
    }
  }

  // refreshPage() {
  //   this.ngZone.run(() => {
  //     this.router.navigate(['/track-appointment']);
  //   });
  // }
}
